import React from "react";
import _pubA97D53F3 from "./atoms.pc";
import _pubBab5A68F, {Preview as _pubBab5A68F_Preview} from "./utils.pc";
import _pub14733275 from "./Checkbox.pc";
import _pub5Ccf593C from "./Toggle.pc";
import _pub5448A231 from "./Detail.pc";
import "./Card.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var $$Default = React.memo(React.forwardRef(function $$Default(props, ref) {
  return React.createElement("div", {
    "className": "_e3fd9c8e _e434fb6a _pub-e434fb6a _pub-a97d53f3" + (props["hover"] ? " " + "_e434fb6a_hover _pub-e434fb6a_hover _pub-a97d53f3_hover hover" : "") + (props["interactive"] ? " " + "_e434fb6a_interactive _pub-e434fb6a_interactive _pub-a97d53f3_interactive interactive" : "") + (props["withAction"] ? " " + "_e434fb6a_withAction _pub-e434fb6a_withAction _pub-a97d53f3_withAction withAction" : "") + (props["spaced"] ? " " + "_e434fb6a_spaced _pub-e434fb6a_spaced _pub-a97d53f3_spaced spaced" : "") + (props["reverse"] ? " " + "_e434fb6a_reverse _pub-e434fb6a_reverse _pub-a97d53f3_reverse reverse" : "") + (props["bgSecondary"] ? " " + "_e434fb6a_background-secondary _pub-e434fb6a_background-secondary _pub-a97d53f3_background-secondary background-secondary" : "") + " " + "_e434fb6a_text-body-medium _pub-e434fb6a_text-body-medium _pub-a97d53f3_text-body-medium text-body-medium _e434fb6a_v3 _pub-e434fb6a_v3 _pub-a97d53f3_v3 v3 " + (props["class"] ? " " + props["class"] : "") + " " + " " + (props["className"] ? " " + props["className"] : ""),
    "ref": ref,
    "onClick": props["onClick"],
    "style": castStyle(props["style"]),
    "interactive": true,
    "data-pc-label": "Card",
    "data-testid": props["testId"],
  }, 
    props["children"]
  )
}));
export default $$Default;


